module.exports = __webpack_public_path__ + "img/96161.d0a04615.svg";